<template>
  <div>
    <SysDialog
      v-model="dialog"
      :largura="400"
      titulo="Confirmação"
      txtBotao="salvar"
      @click:primary="salvarEsseg()"
      @click:hidden-dialog="$emit('fechar-dialog-automatico', false)"
    >
      <p class="subtitle-1">O <span class="font-weight-medium">Estoque de Segurança</span> será calculado automaticamente pelo sistema.</p>
    </SysDialog>
  </div>
</template>

<script>
import SysDialog from '@/components/padraoDeLayout/SysDialog.vue';
import { salvarEssegAutomatico } from "./RequisicoesAPI";

export default {
  name: "Automatico",
  components: { SysDialog },
  props: {
    cobertura_selecionada: {
      type: Number
    },
    fornecedor: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    dialog: false,
    cobertura_esseg: null
  }),
  watch: {
    cobertura_selecionada(valor) {
      this.dialog = valor === 0;
    }
  },
  methods: {
    salvarEsseg() {
      const params = {
        id_grupo: this.$store.getters['usuario/getGrupoCompras'],
        id_fornecedor: this.fornecedor.id,
        tipo_esseg: this.cobertura_selecionada,
        valor_esseg: this.cobertura_esseg,
        ativar_grupo_economico_compra: this.fornecedor.grupo_analise_fornecedores ? 'S' : 'N'
      }

      this.$store.dispatch(
        "loading/addRequisicao",
        salvarEssegAutomatico(params)
          .then(() => {
            this.dialog = false;
            this.cobertura_esseg = null;
            this.$emit('fechar-dialog-automatico', true);
          })
          .catch(() => this.Helpers.logout())
      )
    }
  }
}
</script>

<style>

</style>
